/**
 * FeaturedTile - single featured promo tile.
 * Custom element: <featured-tile>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class FeaturedTile extends ThemeComponent {}
setFunctionName(FeaturedTile, "FeaturedTile");
const propertyTypes = {};
FeaturedTile.prototype.$name = "FeaturedTile";
FeaturedTile.prototype.$info = JSON.parse('{"name":"FeaturedTile","meta":{"isLegacy":false,"selector":"featured-tile"},"props":[],"refs":[]}');
FeaturedTile.prototype.$info.component = FeaturedTile;
for (const prop of FeaturedTile.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("FeaturedTile/FeaturedTile.ts", {
  FeaturedTile: FeaturedTile
}, void 0);